import React, { Component } from "react";
import axios from "axios";
import moment from "moment-jalaali";
import { confirmDialog } from "primereact/confirmdialog"; // To use confirmDialog method
import { Sidebar } from "primereact/sidebar";

import { BrowserRouter, Route, Navigate } from "react-router-dom";
import { Chip } from "primereact/chip";
import { Multiselect } from "multiselect-react-dropdown";
import Server from "./../Server.js";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { AutoComplete } from "primereact/autocomplete";
import DatePicker from "react-datepicker2";

import { connect } from "react-redux";
import { Loader } from "rsuite";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

class SettingsRate extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.FieldRef = React.createRef();
    this.toast = React.createRef();

    this.CreateForm = this.CreateForm.bind(this);
    this.onHideDialog = this.onHideDialog.bind(this);
    this.SetTurnRateList = this.SetTurnRateList.bind(this);
    
    this.state = {
      layout: "list",
      name: "",
      type: "1",
      FId: "",
      DbTableName: "",
      DBTableField: "",
      confirm: false,
      active: true,
      activeInApp: true,
      TableRecords: {},
      usersList: [],
      Keys: [],
      year: moment(new Date()).local("fa").format("jYYYY"),
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(1),
    };
  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0,
      });

      that.GetFields(["fromDate", "untilDate"]);
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }
  SetTurnRateList() {
    let that = this;
    let usersList = this.state.usersList.filter((e) => e.remove != "1");

    let TableRecords = [];
    for (let i = 0; i < this.state.Keys.length; i++) {
      TableRecords.push({
        day: this.state.Keys[i],
        free: this.state.TableRecords["free_" + this.state.Keys[i]] || false,
        isNight: this.state.TableRecords["isNight_" + this.state.Keys[i]] || "",
        isMorning:
          this.state.TableRecords["isMorning_" + this.state.Keys[i]] || "",
        isEvening:
          this.state.TableRecords["isEvening_" + this.state.Keys[i]] || "",
        minCapacity: parseInt(
          this.state.TableRecords["minCapacity_" + this.state.Keys[i]] ||
            this.state.minCapacity
        ),
        maxCapacity: parseInt(
          this.state.TableRecords["maxCapacity_" + this.state.Keys[i]] ||
            this.state.maxCapacity
        ),
      });
    }
    let param = {
      token: localStorage.getItem("api_token"),
      _id: this.state.selectedId,
      number: this.state.number,
      year: this.state.year,
      desc: this.state.desc,
      minCapacity: parseInt(this.state.minCapacity),
      maxCapacity: parseInt(this.state.maxCapacity),
      isMorning: this.state.isMorning,
      isNight: this.state.isNight,
      isEvening: this.state.isEvening,
      sendSms: this.state.sendSms,
      active: this.state.active,
      activeInApp: this.state.activeInApp,
      fromDate: this.state.fromDate,
      untilDate: this.state.untilDate,
      DetailRecords: TableRecords,
      usersList: usersList,
      systemId: this.props.systemId
    };
    this.setState({
      loading: 1,
    });
    this.setState({
      HasErrorForMaps: null,
    });
    let SCallBack = function (response) {
      that.onHideDialog();
      that.GetTurnRateList();
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "success",
        summary: "",
        detail: "عملیات با موفقیت انجام شد",
        life: 3000,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
    };
    this.Server.send("AdminApi/CreateTurnRate", param, SCallBack, ECallBack);
  }
  CreateForm() {
    this.setState({
      visibleManageField: true,
      isMorning: false,
      isEvening: false,
      isNight: false,
      number: "",
      year:  moment(new Date()).local("fa").format("jYYYY"),
      selectedId: null,
      minCapacity: 0,
      maxCapacity: 0,
      active: true,
      activeInApp: true,
      sendSms: true,
      desc: "",
      TableRecords: [],
      usersList: [],
      fromDate: moment(new Date()),
      untilDate: moment(new Date()),
    });
  }
  onHideDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null,
    });
  }
  selectedComponentChange(value) {
    let m = moment;
    let TableRecords = {};
    for (let item of value.records) {
      TableRecords["free_" + item.day] = item.free;
      TableRecords["maxCapacity_" + item.day] = parseInt(item.maxCapacity);
      TableRecords["minCapacity_" + item.day] = parseInt(item.minCapacity);
      TableRecords["isMorning_" + item.day] = item.isMorning;
      TableRecords["isEvening_" + item.day] = item.isEvening;
      TableRecords["isNight_" + item.day] = item.isNight;
    }
    let p = {
      number: value.number,
      year: value.year,
      selectedId: value._id,
      FieldSelected: value.Fields,
      visibleManageField: true,
      desc: value.desc,
      minCapacity: parseInt(value.minCapacity),
      maxCapacity: parseInt(value.maxCapacity),
      isMorning: value.isMorning,
      isEvening: value.isEvening,
      isNight: value.isNight,
      active: value.active,
      activeInApp: value.activeInApp,
      sendSms: value.sendSms,
      TableRecords: TableRecords,
      usersList: value.usersList || [],
    };
    if (value.fromDate) p.fromDate = m(new Date(value.fromDate)).local("fa");
    if (value.untilDate) p.untilDate = m(new Date(value.untilDate)).local("fa");
    this.setState(p, () => {
      this.setTable();
    });
  }
  GetTurnRateList(number) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      GetAll: 1,
      number: number,
      systemId : this.props.systemId
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        GridDataReserve: response.data.result,
      });
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/GetTUrnRateLists", param, SCallBack, ECallBack);
  }
  GetFields(latinName) {
    let that = this;

    let param = {
      token: localStorage.getItem("api_token"),
      latinName: latinName,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      let ShowParam = [];
      let ComboParam = [];
      let CodeParam = [];
      let AutoCompleteParam = [];
      let count = 0;
      let HiddenFields = [];
      for (let item of response.data.result) {
        ShowParam.push({
          name: item.name,
          latinName: item.latinName,
          type: item.type,
          required: item.required,
          title: item.name,
        });
        if (item.type == "2") {
          if (item.Default && item.CheckOkFields) {
            for (let j = 0; j < item.CheckOkFields.split(",").length; j++) {
              HiddenFields.push(item.CheckOkFields.split(",")[j]);
            }
          }
          if (!item.Default && item.CheckNOkFields) {
            for (let j = 0; j < item.CheckNOkFields.split(",").length; j++) {
              HiddenFields.push(item.CheckNOkFields.split(",")[j]);
            }
          }
          that.setState({ [item.latinName]: item.Default });
        }
        if (item.type == "3") {
          ComboParam.push({
            DBTableFieldLabel: item.DBTableFieldLabel,
            DBTableFieldValue: item.DBTableFieldValue,
            DbTableName: item.DbTableName,
            FId: item.FId,
          });
        }
        if (item.type == "6") {
          CodeParam.push({ CodeNum: item.CodeNum, FId: item.FId });
        }
        if (item.type == "4") {
          item.index = count;
          AutoCompleteParam.push({
            index: count,
            latinName: item.latinName,
            DBTableFieldLabel: item.DBTableFieldLabel,
            DBTableFieldValue: item.DBTableFieldValue,
            DbTableName: item.DbTableName,
            FId: item.FId,
          });
          count++;
        }
      }
      that.setState({
        loading: 0,
        Fields: response.data.result,
        ShowParam: ShowParam,
        ComboParam: ComboParam,
        CodeParam: CodeParam,
        AutoCompleteParam: AutoCompleteParam,
        HiddenFields: HiddenFields,
      });
      that.GetTurnRateList();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/GetFields", param, SCallBack, ECallBack);
  }
  setTable() {
    let tt = 0;
    if (this.state.untilDate && this.state.fromDate) {
      let untilDate = this.state.untilDate.local
          ? this.state.untilDate.local("fa").format("jYYYY/jM/jD")
          : this.state.untilDate,
        fromDate = this.state.fromDate.local
          ? this.state.fromDate.local("fa").format("jYYYY/jM/jD")
          : this.state.fromDate;
      tt =
        (untilDate.split("/")[1] - fromDate.split("/")[1]) * 31 +
        (untilDate.split("/")[2] - fromDate.split("/")[2]);
      let TableRecordArray = [];
      let WeekName = parseInt(this.state.fromDate.local("fa").format("d"));
      let WeekNameTemp = WeekName;
      let Day = "",
        DayName = "";
      let d = parseInt(fromDate.split("/")[2]);
      let m = parseInt(fromDate.split("/")[1]);
      let monthPriod = 31;
      let Keys = [];
      let counter = 0;
      for (let i = 0; i < tt; i++) {
        WeekName = WeekNameTemp + counter <= 6 ? WeekNameTemp + counter : 0;
        counter++;
        if (WeekName == 6) {
          counter = 0;
          WeekNameTemp = 0;
        }
        if (i != 0) d = d < monthPriod ? d + 1 : 1;
        m = d == 1 && i != 0 && m < 12 ? m + 1 : m;
        if (m > 6) monthPriod = 30;
        Day = fromDate.split("/")[0] + "/" + m + "/" + d;
        DayName = fromDate.split("/")[0] + "_" + m + "_" + d;
        let param = {
          Day: Day,
          Checked: this.state.TableRecords["checked_" + DayName],
        };
        param["freeName"] = "free_" + DayName;
        param["maxCapacity"] = "maxCapacity_" + DayName;
        param["minCapacity"] = "minCapacity_" + DayName;
        param["isMorning"] = "isMorning_" + DayName;
        param["isEvening"] = "isEvening_" + DayName;
        param["isNight"] = "isNight_" + DayName;
        TableRecordArray.push(param);
        Keys.push(DayName);
      }
      this.setState({
        TableRecord: tt,
        TableRecordArray: TableRecordArray,
        Keys: Keys,
      });
    }
  }

  onSelect(event) {
    let List = this.state.usersList.filter((e) => e.remove != "1");
    List.push({
      title: event.value.name,
      username: event.value.username,
    });
    var flags = [],
      output = [],
      l = List.length,
      i;
    for (i = 0; i < l; i++) {
      if (flags[List[i].title]) continue;
      flags[List[i].title] = true;
      output.push(List[i]);
    }

    this.setState({
      searchName: event.value.name,
      searchId: event.value.username,
      usersList: output,
    });
  }
  suggestBrands(event) {
    let that = this;
    this.setState({ brand: event.query, Count: 0 });
    let param = {};
    param = {
      title: event.query,
      table: "users",
      name: ["name", "username", "RaymandAcc", "RaymandUser"],
    };

    let SCallBack = function (response) {
      let brandSuggestions = [];
      response.data.result.reverse().map(function (v, i) {
        brandSuggestions.push({
          _id: v._id,
          name: v.name,
          username: v.username,
        });
      });
      that.setState({ brandSuggestions: brandSuggestions });
    };

    let ECallBack = function (error) {};
    that.Server.send("AdminApi/searchItems", param, SCallBack, ECallBack);
  }
  itemTemplate(brand) {
    return (
      <div
        className="p-clearfix"
        style={{ direction: "rtl", maxWidth: "100%" }}
      >
        <div
          style={{ margin: "10px 10px 0 0" }}
          className="row"
          username={brand.username}
        >
          <div
            className="col-8"
            username={brand.username}
            style={{ textAlign: "right" }}
          >
            <span
              className="iranyekanwebregular"
              style={{ textAlign: "right", overflow: "hidden" }}
              username={brand.username}
            >
              <span
                style={{ whiteSpace: "pre-wrap" }}
                username={brand.username}
              >
                {brand.name}
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
    );
  }
  render() {
    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={this.SetTurnRateList}
          style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}
        >
          {" "}
          اعمال{" "}
        </button>
      </div>
    );

    const delTemplate = (rowData, props) => {
      return (
        <i
          className="fa fa-times"
          style={{ cursor: "pointer" }}
          aria-hidden="true"
          onClick={() => this.delField(rowData)}
        ></i>
      );
    };

    const fromDateTemplate = (rowData, props) => {
      return (
        <span>{moment(rowData.fromDate).local("fa").format("jYYYY/jM/jD")}</span>
      );
    };

    const untilDateTemplate = (rowData, props) => {
      return (
        <span>{moment(rowData.untilDate).local("fa").format("jYYYY/jM/jD")}</span>
      );
    };

    
    return (
      <div style={{ direction: "rtl" }}>
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <Toast
          ref={this.toast}
          position="top-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />
        <div className="row justify-content-center">
          <div className="col-12" style={{ background: "#fff" }}>
            <div className="row">
              <div className="col-6" style={{ textAlign: "right" }}>
                <button
                  className="btn btn-primary irsans"
                  onClick={this.CreateForm}
                  style={{
                    width: "200px",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  ساخت رکورد جدید
                </button>
              </div>
            </div>
            <div className="section-title " style={{ textAlign: "right" }}>
              <span
                className="title IRANYekan"
                style={{ fontSize: 17, color: "gray" }}
              >
                لیست رکورد ها
              </span>
            </div>

            <DataTable
              responsive
              value={this.state.GridDataReserve}
              selectionMode="single"
              selection={this.state.selectedComponent}
              onSelectionChange={(e) => this.selectedComponentChange(e.value)}
            >
              <Column
                field="number"
                header="شماره فرم"
                className="irsans"
                style={{ textAlign: "right" }}
              />
              <Column
                field="year"
                header="سال"
                className="irsans"
                style={{ textAlign: "right" }}
              />
              <Column
                field="fromDate"
                body={fromDateTemplate}
                header="از تاریخ"
                className="irsans"
                style={{ textAlign: "right" }}
              />
              <Column
                field="untilDate"
                body={untilDateTemplate}
                header="تا تاریخ"
                className="irsans"
                style={{ textAlign: "right" }}
              />
              <Column
                field="minCapacity"
                header="حداقل ظرفیت"
                className="irsans"
                style={{ textAlign: "right" }}
              />
              <Column
                field="maxCapacity"
                header="حداکثر ظرفیت"
                className="irsans"
                style={{ textAlign: "right" }}
              />
              <Column
                field="del"
                body={delTemplate}
                header="حذف"
                className="irsans"
                style={{ textAlign: "right" }}
              />
            </DataTable>
          </div>
        </div>

        <Dialog
          header={this.state.selectedId ? "اصلاح" : "ساخت فرم جدید"}
          visible={this.state.visibleManageField}
          footer={footer}
          onHide={this.onHideDialog}
          maximizable={false}
          maximized={true}
        >
          <form>
            <div className="row">
              <div className="col-lg-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    style={{ maxWidth: 200 }}
                    type="text"
                    value={this.state.number}
                    name="number"
                    onChange={(event) =>
                      this.setState({ number: event.target.value })
                    }
                    required="true"
                  />
                  <label>شماره ردیف</label>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="group">
                  <select
                    className="form-control irsans"
                    id="year"
                    name="year"
                    value={this.state.year}
                    onChange={(event) => {
                      this.setState({ year: event.target.value });
                    }}
                    style={{ maxWidth: 300 }}
                  >
                    <option value="1401">1401</option>
                    <option value="1402">1402</option>
                    <option value="1403">1403</option>
                    <option value="1404">1404</option>
                    <option value="1405">1405</option>
                    <option value="1406">1406</option>
                    <option value="1407">1407</option>
                    <option value="1408">1408</option>
                    <option value="1409">1409</option>
                    <option value="1410">1410</option>
                  </select>
                  <label className="  irsans">سال</label>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.minCapacity}
                    name="minCapacity"
                    onChange={(event) =>
                      this.setState({ minCapacity: event.target.value })
                    }
                    required="true"
                  />
                  <label>حداقل ظرفیت</label>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.maxCapacity}
                    name="maxCapacity"
                    onChange={(event) =>
                      this.setState({ maxCapacity: event.target.value })
                    }
                    required="true"
                  />
                  <label>حداکثر ظرفیت</label>
                </div>
              </div>
              <div className="col-12">
                <div
                  className="group"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    maxWidth: 300,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      inputId="isMorning"
                      value={this.state.isMorning}
                      checked={this.state.isMorning}
                      onChange={(e) => this.setState({ isMorning: e.checked })}
                    ></Checkbox>
                    <label
                      htmlFor="isMorning"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                      صبح
                    </label>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      inputId="isEvening"
                      value={this.state.isEvening}
                      checked={this.state.isEvening}
                      onChange={(e) => this.setState({ isEvening: e.checked })}
                    ></Checkbox>
                    <label
                      htmlFor="isEvening"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                      عصر
                    </label>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      inputId="isNight"
                      value={this.state.isNight}
                      checked={this.state.isNight}
                      onChange={(e) => this.setState({ isNight: e.checked })}
                    ></Checkbox>
                    <label
                      htmlFor="isNight"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                      شب
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-12" style={{ marginTop: 25 }}></div>
              {this.state.ShowParam &&
                this.state.ShowParam.map((item, index) => {
                  if (item.type == "5") {
                    return (
                      <div className="col-12 col-lg-6">
                        <DatePicker
                          onChange={(value) => {
                            this.setState({ [item.latinName]: value });
                            setTimeout(() => {
                              this.setTable();
                            }, 0);
                          }}
                          isGregorian={false}
                          timePicker={false}
                          placeholder={item.name}
                          persianDigits={false}
                          value={this.state[item.latinName]}
                        />
                      </div>
                    );
                  }
                })}

              <div className="col-12" style={{ marginTop: 50 }}>
                {this.state.TableRecordArray &&
                  this.state.TableRecordArray.length > 0 && (
                    <div
                      className="row"
                      style={{
                        alignItems: "baseline",
                        backgroundColor: "#ccc",
                      }}
                    >
                      <div
                        className="col-2 YekanBakhFaBold"
                        style={{ textAlign: "center" }}
                      >
                        تعطیل
                      </div>
                      <div
                        className="col-2 YekanBakhFaBold"
                        style={{ textAlign: "center" }}
                      >
                        روز
                      </div>
                      <div
                        className="col-2 YekanBakhFaBold"
                        style={{ textAlign: "center" }}
                      >
                        ظرفیت
                      </div>
                      <div
                        className="col-2 YekanBakhFaBold"
                        style={{ textAlign: "center" }}
                      >
                        حداکثر ظرفیت
                      </div>
                      {this.state.isMorning && (
                        <div
                          className="col-1 YekanBakhFaBold"
                          style={{ textAlign: "center" }}
                        >
                          صبح
                        </div>
                      )}
                      {this.state.isEvening && (
                        <div
                          className="col-1 YekanBakhFaBold"
                          style={{ textAlign: "center" }}
                        >
                          عصر
                        </div>
                      )}
                      {this.state.isNight && (
                        <div
                          className="col-1 YekanBakhFaBold"
                          style={{ textAlign: "center" }}
                        >
                          شب
                        </div>
                      )}
                    </div>
                  )}
                {this.state.TableRecordArray &&
                  this.state.TableRecordArray.map((item, index) => {
                    let style =
                      index % 2
                        ? {
                            alignItems: "baseline",
                            backgroundColor: "#eee",
                            marginTop: 5,
                          }
                        : {
                            alignItems: "baseline",
                            backgroundColor: "rgb(216 239 234 / 53%)",
                            marginTop: 5,
                          };
                    return (
                      <div className="row" style={style}>
                        <div className="col-2">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Checkbox
                              inputId={item.freeName}
                              value={
                                this.state.TableRecords[item.freeName] ||
                                item[item.freeName]
                              }
                              checked={this.state.TableRecords[item.freeName]}
                              onChange={(event) => {
                                let TableRecords = this.state.TableRecords;
                                TableRecords[item.freeName] = event.checked;
                                this.setState({ TableRecords: TableRecords });
                              }}
                            ></Checkbox>
                          </div>
                        </div>
                        <div
                          className="col-2 YekanBakhFaBold"
                          style={{ textAlign: "center" }}
                        >
                          {item.Day}
                        </div>
                        <div className="col-2">
                          <div>
                            <input
                              className="form-control YekanBakhFaBold"
                              style={{ textAlign: "center" }}
                              type="text"
                              id={item.minCapacity}
                              name={item.minCapacity}
                              value={
                                this.state.TableRecords[item.minCapacity] ||
                                item[item.minCapacity] ||
                                this.state.minCapacity
                              }
                              onChange={(event) => {
                                let TableRecords = this.state.TableRecords;
                                TableRecords[item.minCapacity] =
                                  event.target.value;
                                this.setState({ TableRecords: TableRecords });
                              }}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-2">
                          <div>
                            <input
                              className="form-control YekanBakhFaBold"
                              style={{ textAlign: "center" }}
                              type="text"
                              id={item.maxCapacity}
                              name={item.maxCapacity}
                              value={
                                this.state.TableRecords[item.maxCapacity] ||
                                item[item.maxCapacity] ||
                                this.state.maxCapacity
                              }
                              onChange={(event) => {
                                let TableRecords = this.state.TableRecords;
                                TableRecords[item.maxCapacity] =
                                  event.target.value;
                                this.setState({ TableRecords: TableRecords });
                              }}
                              required
                            />
                          </div>
                        </div>
                        {this.state.isMorning && (
                          <div
                            className="col-1 YekanBakhFaBold"
                            style={{ textAlign: "center" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Checkbox
                                inputId={item.isMorning}
                                value={
                                  this.state.TableRecords[item.isMorning] ||
                                  item[item.isMorning]
                                }
                                checked={
                                  this.state.TableRecords[item.isMorning]
                                }
                                onChange={(event) => {
                                  let TableRecords = this.state.TableRecords;
                                  TableRecords[item.isMorning] = event.checked;
                                  this.setState({ TableRecords: TableRecords });
                                }}
                              ></Checkbox>
                            </div>
                          </div>
                        )}
                        {this.state.isEvening && (
                          <div
                            className="col-1 YekanBakhFaBold"
                            style={{ textAlign: "center" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Checkbox
                                inputId={item.isEvening}
                                value={
                                  this.state.TableRecords[item.isEvening] ||
                                  item[item.isEvening]
                                }
                                checked={
                                  this.state.TableRecords[item.isEvening]
                                }
                                onChange={(event) => {
                                  let TableRecords = this.state.TableRecords;
                                  TableRecords[item.isEvening] = event.checked;
                                  this.setState({ TableRecords: TableRecords });
                                }}
                              ></Checkbox>
                            </div>
                          </div>
                        )}
                        {this.state.isNight && (
                          <div
                            className="col-1 YekanBakhFaBold"
                            style={{ textAlign: "center" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Checkbox
                                inputId={item.isNight}
                                value={
                                  this.state.TableRecords[item.isNight] ||
                                  item[item.isNight]
                                }
                                checked={this.state.TableRecords[item.isNight]}
                                onChange={(event) => {
                                  let TableRecords = this.state.TableRecords;
                                  TableRecords[item.isNight] = event.checked;
                                  this.setState({ TableRecords: TableRecords });
                                }}
                              ></Checkbox>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
              <div className="col-lg-12">
                <div className="group">
                  <textarea
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.desc}
                    name="desc"
                    onChange={(event) =>
                      this.setState({ desc: event.target.value })
                    }
                    required="true"
                  ></textarea>
                  <label>توضیح</label>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="group">
                  <AutoComplete
                    placeholder="کاربران (باجه)"
                    style={{ width: "100%" }}
                    onChange={(event) => {
                      this.setState({ searchName: event.value });
                    }}
                    itemTemplate={this.itemTemplate.bind(this)}
                    value={this.state.searchName}
                    onSelect={(e) => this.onSelect(e)}
                    suggestions={this.state.brandSuggestions}
                    completeMethod={this.suggestBrands.bind(this)}
                  />
                  <div
                    style={{
                      marginTop: 10,
                      textAlign: "right",
                      marginBottom: 10,
                    }}
                  >
                    {typeof this.state.usersList == "object" &&
                      this.state.usersList.map((v, i) => {
                        if ((v.title || v.username) && !v.remove) {
                          return (
                            <Chip
                              label={v.title || v.username}
                              _id={v._id}
                              style={{ marginLeft: 5 }}
                              removable={true}
                              onRemove={(event) => {
                                let title =
                                  event.target.parentElement.getElementsByClassName(
                                    "p-chip-text"
                                  )[0].textContent;
                                let List = this.state.usersList;
                                for (let i = 0; i < List.length; i++) {
                                  if (
                                    List[i].title == title ||
                                    List[i].username == title
                                  ) {
                                    List[i].remove = 1;
                                  }
                                }
                              }}
                            />
                          );
                        }
                      })}
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="group">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      inputId="active"
                      value={this.state.active}
                      checked={this.state.active}
                      onChange={(e) => this.setState({ active: e.checked })}
                    ></Checkbox>
                    <label
                      htmlFor="active"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                      فعال
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="group">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      inputId="sendSms"
                      value={this.state.sendSms}
                      checked={this.state.sendSms}
                      onChange={(e) => this.setState({ sendSms: e.checked })}
                    ></Checkbox>
                    <label
                      htmlFor="sendSms"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                      ارسال پیامک
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="group">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      inputId="activeInApp"
                      value={this.state.activeInApp}
                      checked={this.state.activeInApp}
                      onChange={(e) => this.setState({ activeInApp: e.checked })}
                    ></Checkbox>
                    <label
                      htmlFor="activeInApp"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                      رزرو از طریق اپلیکیشن انجام شود
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Dialog>
        <Sidebar
          visible={this.state.SidebarVisible}
          onHide={() =>
            this.setState({
              currentItem: "",
              currentStatus: "",
              SidebarVisible: false,
              ReserveMobile: "",
              ReserveName: "",
              ReserveAcc: "",
            })
          }
        >
          <div style={{ textAlign: "center", marginTop: 70 }}>
            {this.state.currentItem && (
              <div>
                <div
                  className="YekanBakhFaBold"
                  style={{ textAlign: "center", color: "red" }}
                >
                  {!this.state.currentStatus
                    ? "لغو رزرو روز " + this.state.currentItem.Day
                    : " رزرو روز " + this.state.currentItem.Day}
                </div>
                {this.state.currentStatus ? (
                  <div>
                    <div className="group">
                      <input
                        className="form-control YekanBakhFaBold"
                        style={{ textAlign: "center" }}
                        type="text"
                        id="ReserveName"
                        name="ReserveName"
                        value={this.state.ReserveName}
                        onChange={(event) => {
                          this.setState({ ReserveName: event.target.value });
                        }}
                        required
                      />
                      <label className="YekanBakhFaBold">نام</label>
                    </div>
                    <div className="group">
                      <input
                        className="form-control YekanBakhFaBold"
                        style={{ textAlign: "center" }}
                        type="text"
                        id="ReserveMobile"
                        name="ReserveMobile"
                        value={this.state.ReserveMobile}
                        onChange={(event) => {
                          this.setState({ ReserveMobile: event.target.value });
                        }}
                        required
                      />
                      <label className="YekanBakhFaBold">تلفن همراه</label>
                    </div>
                    <div className="group">
                      <input
                        className="form-control YekanBakhFaBold"
                        style={{ textAlign: "center" }}
                        type="text"
                        id="ReserveAcc"
                        name="ReserveAcc"
                        value={this.state.ReserveAcc}
                        onChange={(event) => {
                          this.setState({ ReserveAcc: event.target.value });
                        }}
                        required
                      />
                      <label className="YekanBakhFaBold">شماره حساب</label>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div
                      className="YekanBakhFaBold"
                      style={{ textAlign: "center" }}
                    >
                      این روز قبلا توسط{" "}
                      <span style={{ fontSize: 22 }}>
                        {this.state.currentItem.name}
                      </span>{" "}
                      رزرو شده است
                    </div>
                    <div
                      className="YekanBakhFaBold"
                      style={{ textAlign: "center" }}
                    >
                      در صورت لغو رزرو امکان برگشت وجود نخواهد داشت
                    </div>
                  </div>
                )}
              </div>
            )}
            <button
              className="btn btn-primary irsans"
              onClick={this.ManualReserveSet}
              style={{ marginTop: "20px", marginBottom: "20px" }}
            >
              {" "}
              ثبت اولیه{" "}
            </button>
            <div className="YekanBakhFaBold">
              برای نهایی شدن تغییرات باید حتما گزینه اعمال فرم را کلیک کنید
            </div>
          </div>
        </Sidebar>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(SettingsRate);
